import clsx from 'clsx'
import { Check } from 'lucide-react'
import React, { ReactNode, useId, useState } from 'react'

type CheckBoxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  defaultChecked?: boolean
  disabled?: boolean
  label?: ReactNode
  onChange?: (value: boolean) => void
  error?: boolean
  className?: string
}

const CheckBox = React.forwardRef<HTMLInputElement, CheckBoxProps>(
  ({ defaultChecked, disabled, onChange, label, className, error, ...props }, ref) => {
    const [checked, setChecked] = useState(defaultChecked)
    const id = useId()

    const handleChange = () => {
      if (disabled) return

      if (onChange) {
        onChange(!checked)
      }
      setChecked(!checked)
    }

    return (
      <div className={className}>
        <input
          type="checkbox"
          ref={ref}
          id={id}
          checked={checked}
          onChange={() => handleChange()}
          disabled={disabled}
          className={'hidden'}
          {...props}
        />
        <label htmlFor={id} className="flex cursor-pointer items-start text-sm">
          <div
            className={clsx(
              'border-gray-90 mr-2 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-sm border border-solid transition-colors duration-300',
              checked && 'border-[var(--colorGreen)] text-[var(--colorGreen)]',
              error && 'border-[var(--colorError)] text-[var(--colorError)]'
            )}
          >
            {checked && <Check width="10" height="10" />}
          </div>
          {label && <span className='-mt-0.5 select-none'>{label}</span>}
        </label>
      </div>
    )
  }
)

CheckBox.displayName = 'CheckBox'

export default CheckBox
